import React, { useState } from 'react';
import { Button } from 'components/Button/Button';
import { useNavigate } from 'features/cobrand/hooks/useCobrandUtils';
import { useTranslationContext } from 'contexts/TranslationContext/TranslationContext';
import { useDeviceType } from 'contexts/ThemeContext/hooks/useDeviceType';
import { ConfirmationDialog } from 'components/ConfirmationDialog/ConfirmationDialog';

export const DeactivateAccount = () => {
  const [confirmDeactivateOpen, setConfirmDeactivateOpen] = useState(false);

  const { translation } = useTranslationContext();
  const navigate = useNavigate();
  const { isDesktop } = useDeviceType();

  const handleDeactivateClick = () => {
    setConfirmDeactivateOpen(true);
  };

  const handleConfirmDeactivate = () => {
    setConfirmDeactivateOpen(false);
    // Only add section=chat on mobile/tablet - desktop shows both panels simultaneously
    const chatUrl = !isDesktop ? '/home?section=chat&deactivate=true' : '/home?deactivate=true';
    navigate(chatUrl);
  };

  const handleCancelDeactivate = () => {
    setConfirmDeactivateOpen(false);
  };

  return (
    <div className="deactivate-account">
      <Button
        id="deactivate-account-button"
        className="deactivate-account__button"
        variant="outlined"
        size="large"
        onClick={handleDeactivateClick}
      >
        {translation('deactivate_account_header')}
      </Button>
      <ConfirmationDialog
        id="deactivate-account-confirmation-dialog"
        className="deactivate-account__confirmation-dialog"
        PaperProps={{
          sx: {
            maxWidth: '300px',
          },
        }}
        title="This will redirect you to chat. Continue?"
        yesButtonLabel={translation('continue_button_title')}
        noButtonLabel={translation('cancel')}
        open={confirmDeactivateOpen}
        handleYes={handleConfirmDeactivate}
        handleNo={handleCancelDeactivate}
        dialogTitleProps={{
          sx: {
            lineHeight: 1.25,
            pt: 3,
          },
        }}
      />
    </div>
  );
};
